import configs from "utils/globals";
import { useTranslation } from "react-i18next";
import { ReactComponent as Failed } from "assets/icons/failed.svg";
import { ReactComponent as Success } from "assets/icons/success.svg";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-dashed.svg";

import {
  renderReceiptTitle,
  renderReceiptText,
  paymentMethodType,
} from "containers/operationsReceipt/services/data.transformers";

const ContentReceipt = ({
  account,
  bank_reference,
  status,
  updated_at,
  amount = 0,
  user = {},
  destination_address,
  destination_icon,
  destination_title,
  transaction_type,
}) => {
  const { t } = useTranslation();

  const renderSourceAccount = () => {
    if (`${transaction_type}`.toLowerCase() === "card") {
      const cardNumber = `${account?.card_number}`
        .split("")
        .map((el, index) => (index > 5 && index < 12 ? "*" : el))
        .join("")
        .match(/.{1,4}/g)
        .join(" ");
      const destinationAddress = `${destination_address}`
        .split("")
        .map((el, index) => (index > 5 && index < 12 ? "*" : el))
        .join("")
        .match(/.{1,4}/g)
        .join(" ");

      return [cardNumber, destinationAddress];
    }

    const accountNumber = `${account?.account_number}`.replaceAll("/", " / ");
    return [accountNumber, destination_address];
  };

  const renderSourceAndDescription = () => {
    return (
      <div className="mt-5 border-t border-b border-gary--8 py-5">
        <div className="body-14px-medium text-gray-4">{user.name}</div>
        <div className="flex items-center justify-center gap-3">
          <span className="body-14px-medium text-gray-4 ltr">
            {renderSourceAccount()[0]}
          </span>
          <div className="h-10 w-10 rounded-xl bg-primary--7 flex items-center justify-center">
            <img
              alt="logo"
              src={
                "https://cdn.firouzeh.com/public/logo-firouzeh-without-typo.svg"
              }
              className="w-6"
            />
          </div>
        </div>
        <div className="table m-auto">
          <ArrowDown className="[&>path]:stroke-primary-0 w-6" />
        </div>

        <div className="body-14px-medium text-gray-4">{destination_title}</div>
        <div className="flex items-center justify-center gap-3">
          <span className="body-14px-medium text-gray-4 ltr">
            {renderSourceAccount()[1]}
          </span>
          <div className="h-10 w-10 rounded-xl bg-primary--7 flex items-center justify-center">
            {destination_icon && (
              <img src={destination_icon} className="w-6" alt="" title="" />
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="text-center px-4">
      <div className="w-12 h-12 table m-auto mb-2 mt-4">
        <div className="w-12 h-12 relative flex justify-center items-center">
          {status === "DONE" && <Success className="w-12 h-12 " />}
          {["FAILED", "TROUBLESHOOTING"].includes(status) && (
            <Failed className="w-12 h-12 " />
          )}
        </div>
      </div>
      <div
        className={`text-center ${renderReceiptText(
          status
        )} body-16px-medium mb-3`}
      >
        {t(renderReceiptTitle(status))}
      </div>
      <div className="body-14px-medium text-gray-0 mb-3">
        {t("bank.pay-from-firouzeh")}
      </div>
      <div className="flex gap-1 justify-center">
        <span className="h-20px-demibold text-gray-4">
          {amount?.toLocaleString()}
        </span>
        <span className="body-16px-regular text-gray-4">{t("rial")}</span>
      </div>
      {renderSourceAndDescription()}
      <div className="pt-5 mt-5">
        <div className="flex justify-between items-center">
          <span className="body-14px-medium text-gray-0 mb-3">
            {t("bank.date-and-time")}
          </span>
          <span className="body-14px-medium text-gray-4 ltr">
            {configs.converToPersianDateTime(updated_at)}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="body-14px-medium text-gray-0 mb-3">
            {t("bank.payment-method")}
          </span>
          <span className="body-14px-medium text-gray-4">
            {paymentMethodType({ transaction_type, t })}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="body-14px-medium text-gray-0 mb-3">
            {t("bank.tracking-code")}
          </span>
          <span className="body-14px-medium text-gray-4">{bank_reference}</span>
        </div>
      </div>
    </div>
  );
};

export default ContentReceipt;
